import { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Glassmorphism surface for V2 cards/panels.
 * Reference: docs/design-guidelines.md §2
 */
export default function GlassCard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl",
        "p-6 md:p-8",
        className
      )}
    >
      {children}
    </div>
  );
}
